import {
    PROGRESSIDVPLAN_FETCHING,
    PROGRESSIDVPLAN_FAILED,
    PROGRESSIDVPLAN_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case PROGRESSIDVPLAN_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case PROGRESSIDVPLAN_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case PROGRESSIDVPLAN_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  